import { Stack, useLocalSearchParams } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { FullHeightWrapper } from '~/layout/components/full-height-wrapper/FullHeightWrapper';
import { WorkoutBuilderHeader } from '~/workout/components/workout-builder-header/WorkoutBuilderHeader';
import { useLivePowerSyncQuery } from '~/powersync/hooks/useLivePowerSyncQuery';
import { db } from '@/lib/local-api';
import type { WorkoutRecord } from '~/powersync/generated/schema';
import { WorkoutBuilderSidebar } from '~/workout/components/workout-builder-sidebar/WorkoutBuilderSidebar';

export default function WorkoutLayout() {
  const { t } = useTranslation('workout');
  const params = useLocalSearchParams();

  const { data: workout } = useLivePowerSyncQuery<WorkoutRecord>(
    params.id ? db.Workout.queries.findByNiceId(params.id as string) : null,
    [params.id],
    { enabled: !!params.id, single: true },
  );

  const isCreateMode = !params.id;
  const headerTitle = isCreateMode
    ? t('form.title.create')
    : workout?.name || t('form.title.detail');

  return (
    <FullHeightWrapper>
      {/* No rail on create — a workout must exist before it can be chatted
          about or have favourite exercises added to it. */}
      {!isCreateMode && (
        <WorkoutBuilderSidebar workoutId={workout?.id ?? null} />
      )}
      <WorkoutBuilderHeader title={headerTitle} workout={workout} />
      <Stack screenOptions={{ headerShown: false }}>
        <Stack.Screen name="create" />
        <Stack.Screen name="[id]/index" options={{ animation: 'none' }} />
        <Stack.Screen name="[id]/progress" options={{ animation: 'none' }} />
      </Stack>
    </FullHeightWrapper>
  );
}
